import { createFileRoute } from '@tanstack/react-router';
import { EventDetailPage } from '@web/modules/campaigns/events/event-detail-page';

export const Route = createFileRoute('/_app/campaigns/events/$eventId')({
  component: EventRoute,
});

function EventRoute() {
  const { eventId } = Route.useParams();
  return <EventDetailPage eventId={eventId} />;
}
